import { HashRouter as Router } from 'react-router-dom';
import Content from '@context/Content';
import Header from '@components/Header';
import Footer from '@components/Footer';
import styled from '@emotion/styled';
import { SHOW_HEADER } from '@utils/globals';

const AppContainer = styled.div(() => ({
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column'
}));

function App() {
    return (
        <Router>
            <AppContainer>
                { SHOW_HEADER ? <Header /> : null }
                <Content />
                <Footer />
            </AppContainer>
        </Router>
    );
}

export default App;
